'use strict';

import CacheService from 'App/services/CacheService';

angular.module('services.cacheService', []).factory('CacheService', [() => CacheService]);
